export default "__VITE_ASSET__BjzAY2Xs__"